import { render, staticRenderFns } from "./ModalTeacherAdd.vue?vue&type=template&id=343c2264&scoped=true&lang=pug&"
import script from "./ModalTeacherAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalTeacherAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalTeacherAdd.vue?vue&type=style&index=0&id=343c2264&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343c2264",
  null
  
)

export default component.exports